import React from "react"
import DocumentSettingsForm from "src/features/documents/components/DocumentSettingsForm"

export default function DocumentTemplatesPage() {
  return <DocumentSettingsForm />
}
